jQuery(document).ready(function () {
  // Define menu breakpoint for mobile handling
  const menuWidth = 1024;

  function scrollToResults() {
    const urlParams = new URLSearchParams(window.location.search);
    const hasFilters = urlParams.has('seasons') || 
                      urlParams.has('activities') || 
                      urlParams.has('pourvoiries') || 
                      urlParams.has('prices') || 
                      urlParams.has('family') ||
                      urlParams.has('search');
    
    if (hasFilters) {
      const $resultsSection = jQuery('.listing-packages, .listing-outfitters').first();
      
      if ($resultsSection.length) {
        setTimeout(function() {
          jQuery('html, body').animate({
            scrollTop: $resultsSection.offset().top - 325
          }, 500);
        }, 100);
      }
    }
  }
  
  // Execute scroll on page load
  scrollToResults();
  
  jQuery(document).on("click", ".filter-item", charlToggleFilterMenu);

  /**
   * Handle outfitter filtering with dropdown menus
   */
  const $filterDropdowns = jQuery('.filter-dropdown');
  const $applyButtons = jQuery('.apply-filter-btn');
  const $clearButtons = jQuery('.clear-filter-btn');
  const $searchForm = jQuery('#outfitter-search-form');



  /**
   * Keep dropdown open when clicking inside
   */
  $filterDropdowns.on('click', function (event) {
      event.stopPropagation();
  });

  /**
   * Close dropdowns when clicking outside
   */
  jQuery(document).on('click', function (event) {
      if (!jQuery(event.target).closest('.filter-item').length) {
      }
  });

 jQuery('.season-checkbox').on('change', function () {
        var $form = jQuery(this).closest('form');
        var formData = new FormData($form[0]);
        var urlParams = new URLSearchParams();

        var $searchInput = $form.find('input[name="search"]');
        if ($searchInput.length && $searchInput.val()) {
            urlParams.append('search', $searchInput.val());
        }

        var selectedSeasons = formData.getAll('seasons[]');
        selectedSeasons.forEach(function (season) {
            urlParams.append('seasons[]', season);
        });

                jQuery('.activity-checkbox:checked').each(function () {
            urlParams.append('activities[]', jQuery(this).val());
        });

                jQuery('.outfitter-checkbox:checked').each(function () {
            urlParams.append('outfitters[]', jQuery(this).val());
        });

        var baseUrl = window.location.pathname;
        var newUrl = selectedSeasons.length > 0 || $searchInput.val()
            ? baseUrl + '?' + urlParams.toString()
            : baseUrl;

        window.location.href = newUrl;
    });

    jQuery('.activity-checkbox').on('change', function () {
        var $form = jQuery(this).closest('form');
        var formData = new FormData($form[0]);
        var urlParams = new URLSearchParams();

        var $searchInput = $form.find('input[name="search"]');
        if ($searchInput.length && $searchInput.val()) {
            urlParams.append('search', $searchInput.val());
        }

        var selectedActivities = formData.getAll('activities[]');
        selectedActivities.forEach(function (activity) {
            urlParams.append('activities[]', activity);
        });

        jQuery('.season-checkbox:checked').each(function () {
            urlParams.append('seasons[]', jQuery(this).val());
        });

                jQuery('.outfitter-checkbox:checked').each(function () {
            urlParams.append('outfitters[]', jQuery(this).val());
        });

        var baseUrl = window.location.pathname;
        var newUrl = selectedActivities.length > 0 || $searchInput.val()
            ? baseUrl + '?' + urlParams.toString()
            : baseUrl;

        window.location.href = newUrl;
    });

        jQuery('.outfitter-checkbox').on('change', function () {
        var $form = jQuery(this).closest('form');
        var formData = new FormData($form[0]);
        var urlParams = new URLSearchParams();

        var $searchInput = $form.find('input[name="search"]');
        if ($searchInput.length && $searchInput.val()) {
            urlParams.append('search', $searchInput.val());
        }

        var selectedOutfitters = formData.getAll('outfitters[]');
        selectedOutfitters.forEach(function (outfitter) {
            urlParams.append('outfitters[]', outfitter);
        });

        jQuery('.season-checkbox:checked').each(function () {
            urlParams.append('seasons[]', jQuery(this).val());
        });

                jQuery('.outfitter-checkbox:checked').each(function () {
            urlParams.append('outfitters[]', jQuery(this).val());
        });

        var baseUrl = window.location.pathname;
        var newUrl = selectedOutfitters.length > 0 || $searchInput.val()
            ? baseUrl + '?' + urlParams.toString()
            : baseUrl;

        window.location.href = newUrl;
    });

  /**
   * Clear specific filter
   */
  $clearButtons.on('click', function () {
      const $form = jQuery(this).closest('form');
      $form.find('input[type="checkbox"]').prop('checked', false);
      
      jQuery(this).siblings('.apply-filter-btn').trigger('click');
  });

  /**
   * Handle outfitter filtering with instant checkbox application
   * Builds clean URL parameters with comma-separated values
   * Preserves all active filters when toggling checkboxes
   */
  /**
   * Apply filter instantly when clicking on a checkbox
   */
  jQuery('.season-checkbox, .activity-checkbox, .outfitter-checkbox, .price-checkbox, .family-checkbox').on('change', function () {
      var urlParts = [];

      // Add search term if present
      var searchValue = jQuery('#outfitter-search-input').val();
      if (searchValue) {
          urlParts.push('search=' + encodeURIComponent(searchValue));

      }

      // Get all selected seasons from both forms
      var selectedSeasons = [];
      jQuery('.season-checkbox:checked').each(function() {
          selectedSeasons.push(jQuery(this).val());
      });
      
      if (selectedSeasons.length > 0) {
          urlParts.push('seasons=' + selectedSeasons.map(function(s) { 
              return encodeURIComponent(s); 
          }).join(','));
      }

      // Get all selected activities from both forms
      var selectedActivities = [];
      jQuery('.activity-checkbox:checked').each(function() {
          selectedActivities.push(jQuery(this).val());
      });
      
      if (selectedActivities.length > 0) {
          urlParts.push('activities=' + selectedActivities.map(function(a) { 
              return encodeURIComponent(a); 
          }).join(','));
      }

      // Get all selected outfitters from both forms
      var selectedOutfitters = [];
      jQuery('.outfitter-checkbox:checked').each(function() {
          selectedOutfitters.push(jQuery(this).val());
      });
      
      if (selectedOutfitters.length > 0) {
          urlParts.push('pourvoiries=' + selectedOutfitters.map(function(o) { 
              return encodeURIComponent(o); 
          }).join(','));
      }

      // Get all selected prices from both forms
      var selectedPrices = [];
      jQuery('.price-checkbox:checked').each(function() {
          selectedPrices.push(jQuery(this).val());
      });
      
      if (selectedPrices.length > 0) {
          urlParts.push('prices=' + selectedPrices.map(function(p) { 
              return encodeURIComponent(p); 
          }).join(','));
      }

      // Check if family filter is checked
      if (jQuery('.family-checkbox').is(':checked')) {
          urlParts.push('family=1');
      }

      // Build new URL with clean parameters
      var baseUrl = window.location.pathname;
      var queryString = urlParts.join('&');
      var newUrl = queryString ? baseUrl + '?' + queryString : baseUrl;

      window.location.href = newUrl;
  });

  /**
   * Prevent label click from navigating away
   * Toggle checkbox when clicking on the label
   */
  jQuery('.filter-dropdown label').on('click', function(e) {
      // Only prevent default if clicking on the span, not the checkbox itself
      if (!jQuery(e.target).is('input[type="checkbox"]')) {
          e.preventDefault();
          e.stopPropagation();
          
          // Toggle the checkbox
          var $checkbox = jQuery(this).find('input[type="checkbox"]');
          $checkbox.prop('checked', !$checkbox.prop('checked')).trigger('change');
      }
  });

  /**
   * Handle search form submission
   */
  jQuery('#outfitter-search-form').on('submit', function (e) {
      e.preventDefault();
      
      var searchTerm = jQuery(this).find('input[name="search"]').val();
      var urlParams = new URLSearchParams(window.location.search);
      var urlParts = [];

      if (searchTerm) {
          urlParts.push('search=' + encodeURIComponent(searchTerm));
      }

      // Preserve existing filters
      var seasons = urlParams.get('seasons');
      var activities = urlParams.get('activities');
      var outfitters = urlParams.get('outfitters');
      var prices = urlParams.get('prices');

      if (seasons) {
          urlParts.push('seasons=' + encodeURIComponent(seasons));
      }

      if (activities) {
          urlParts.push('activities=' + encodeURIComponent(activities));
      }

      if (outfitters) {
          urlParts.push('outfitters=' + encodeURIComponent(outfitters));
      }

      if (prices) {
          urlParts.push('prices=' + encodeURIComponent(prices));
      }

      var baseUrl = window.location.pathname;
      var queryString = urlParts.join('&');
      var newUrl = queryString ? baseUrl + '?' + queryString : baseUrl;
      
      window.location.href = newUrl;
  });

  /**
   * Toggle filter dropdown menu for mobile devices
   */
function charlToggleFilterMenu(e) {
  if (jQuery(window).width() < menuWidth) {
    e.preventDefault();
    e.stopPropagation();
    
    const $filterItem = jQuery(this);
    const $swiperContainer = $filterItem.closest('.filters-carousel');
    
    if ($swiperContainer.length && $swiperContainer[0].swiper) {
      const swiper = $swiperContainer[0].swiper;
      const slideIndex = $filterItem.index();
      
      const slide = swiper.slides[slideIndex];
      const slideOffset = slide.offsetLeft;
      
      const offsetWithPadding = slideOffset - 64;
      
      swiper.setTransition(300);
      swiper.setTranslate(-offsetWithPadding);
      swiper.updateProgress();
      
      setTimeout(function() {
        jQuery('.filter-item').not($filterItem).removeClass('mobile-open');
        
        $filterItem.toggleClass('mobile-open');
      }, 300);
    } else {
      jQuery('.filter-item').not($filterItem).removeClass('mobile-open');
      $filterItem.toggleClass('mobile-open');
    }
  }
}
});

